import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-647dd0d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LogContainer" }
const _hoisted_2 = { style: {"margin-bottom":"15px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "日志信息", -1))

import { useRoute } from 'vue-router';
import { onMounted, computed, ref, watch } from "vue";
import { logAPI, errLogAPI } from '@/api/log';
import { LogMsgCategory, LogDisplay, LogMsg, ErrLogMsgCategory, ErrLogMsg, logLevelFilter } from '@/store/modules/log/types';
import { InfoFilled } from '@element-plus/icons-vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "LogListWindow"
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const logCategorySlice = ref<LogMsgCategory[]>([])
const logSlice = ref<LogDisplay[]>([])
const errLogCategorySlice = ref<ErrLogMsgCategory[]>([])
const errLogSlice = ref<ErrLogMsg[]>([])

const nowLogCategory = ref<LogMsgCategory>()
const nowErrLogCategory = ref<ErrLogMsgCategory>()

const logType = ref<string>("log")
const isLoading = ref<boolean>(false)
const logTypeOptions = [
    {
        value: "log",
        label: "基础日志",
    },
    {
        value: "error",
        label: "错误日志",
    },
]

const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);

const filterForChange = (value: string, row: any, column: any) => {
    return row[column['property']] === value;
}

const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}

const handleChangeRunId = async (data: LogMsgCategory) => {
    isLoading.value = true
    if (logType.value === 'log') {
        nowLogCategory.value = data
        const res = await logAPI.getLogMsgLlistByProjIdAndUidAndRunId(projectId.value, targetId.value, nowLogCategory.value.runId)
        let logDisplaySlice: LogDisplay[] = []
        for (let i = 0; i < res.length; i++) {
            const data = getLogDisplay(res[i])
            if (data !== null) {
                logDisplaySlice.push(data)
            }
        }
        logSlice.value = logDisplaySlice
    } else if (logType.value === 'error') {
        nowErrLogCategory.value = data
        errLogSlice.value = await errLogAPI.getErrLogMsgLlistByProjIdAndUidAndRunId(projectId.value, targetId.value, nowErrLogCategory.value.runId)
    }
    isLoading.value = false
}

const getLogDisplay = (data: LogMsg): LogDisplay | null => {
    const str = data.logInfo
    const regexPattern = /(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}) \(([-+])(\d+)\) <([^<>]+)> \[([^[\]]+)] -> \[(.*)]/
    const match: RegExpMatchArray | null = str.match(regexPattern);

    if (match) {
        const diff = (Number(match[4]) < 10 ? '0' : '') + match[4] + ':00'
        const res: LogDisplay = {
            logNumber: data.logNumber,
            logTime: getDisplayTime(match[1] + 'T' + match[2] + match[3] + diff),
            logModule: match[5],
            logType: match[6],
            logContent: match[7],
        }
        return res
    } else {
        return null
    }
}

const AsyncGetLogMsgList = async () => {
    isLoading.value = true
    logCategorySlice.value = await logAPI.getLogCategoryByProjIdAndUid(projectId.value, targetId.value)
    if (logCategorySlice.value && logCategorySlice.value.length > 0) {
        nowLogCategory.value = logCategorySlice.value[0]
        const res = await logAPI.getLogMsgLlistByProjIdAndUidAndRunId(projectId.value, targetId.value, logCategorySlice.value[0].runId)
        let logDisplaySlice: LogDisplay[] = []
        for (let i = 0; i < res.length; i++) {
            const data = getLogDisplay(res[i])
            if (data !== null) {
                logDisplaySlice.push(data)
            }
        }
        logSlice.value = logDisplaySlice
    }
    isLoading.value = false
}

const AsyncGetErrorLogMsgList = async () => {
    isLoading.value = true
    errLogCategorySlice.value = await errLogAPI.getErrLogMsgCategoryListByProjIdAndUid(projectId.value, targetId.value)
    if (errLogCategorySlice.value && errLogCategorySlice.value.length > 0) {
        nowErrLogCategory.value = errLogCategorySlice.value[0]
        errLogSlice.value = await errLogAPI.getErrLogMsgLlistByProjIdAndUidAndRunId(projectId.value, targetId.value, errLogCategorySlice.value[0].runId)
    }
    isLoading.value = false
}

watch(logType, async (newValue: any, oldValue: any) => {
    if (logType.value === 'log') {
        await AsyncGetLogMsgList()
    } else if (logType.value === 'error') {
        await AsyncGetErrorLogMsgList()
    }
})

onMounted(async () => {
    await AsyncGetLogMsgList()
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_popover, {
        class: "elPopover",
        placement: "bottom",
        title: " ",
        width: 500,
        trigger: "hover",
        "popper-style": "max-height:60vh;overflow-y:auto"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"float":"right","margin-right":"50px","margin-top":"30px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换时间")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (logType.value === 'log' || logType.value === 'error')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_timeline, {
                key: 0,
                class: "TimeLinePopover"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logType.value === 'log' ? logCategorySlice.value : (logType.value === 'error' ? errLogCategorySlice.value : []), (category, index) => {
                    return (_openBlock(), _createBlock(_component_el_timeline_item, {
                      key: index,
                      timestamp: getDisplayTime(category.updated) + '  (RunID: ' + category.runId + ') ',
                      onClick: ($event: any) => (handleChangeRunId(category)),
                      type: category === (logType.value === 'log' ? nowLogCategory.value : (logType.value === 'error' ? nowErrLogCategory.value : {})) ? 'primary' : '',
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_2, [
                          _createTextVNode(" 共包含 " + _toDisplayString(category.totalCount) + " 条日志 ", 1),
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: 'taskId: ' + category.taskId,
                            placement: "bottom"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(InfoFilled))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["timestamp", "onClick", "type"]))
                  }), 128))
                ]),
                _: 1
              })), [
                [_directive_loading, isLoading.value]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode("日志类型： "),
          _createVNode(_component_el_select, {
            modelValue: logType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((logType).value = $event)),
            placeholder: "Select"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(logTypeOptions, (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    (logType.value === 'log')
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          class: "logTable",
          data: logSlice.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              width: "50"
            }),
            _createVNode(_component_el_table_column, {
              prop: "logTime",
              label: "时间",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              prop: "logModule",
              label: "模块",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              prop: "logType",
              label: "等级",
              width: "150",
              filters: _unref(logLevelFilter),
              "filter-method": filterForChange,
              "filter-multiple": false
            }, {
              default: _withCtx((scope) => [
                (scope.row.logType === 'INFO')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("INFO")
                      ]),
                      _: 1
                    }))
                  : (scope.row.logType === 'SUCCE')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("SUCCE")
                        ]),
                        _: 1
                      }))
                    : (scope.row.logType === 'WARN')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 2,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("WARN")
                          ]),
                          _: 1
                        }))
                      : (scope.row.logType === 'ERROR')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 3,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("ERROR")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_tag, {
                            key: 4,
                            type: "INFO"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("UNKNOWN")
                            ]),
                            _: 1
                          }))
              ]),
              _: 1
            }, 8, ["filters"]),
            _createVNode(_component_el_table_column, {
              prop: "logContent",
              label: "内容"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isLoading.value]
        ])
      : (logType.value === 'error')
        ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            class: "logTable",
            data: errLogSlice.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                width: "50"
              }),
              _createVNode(_component_el_table_column, {
                prop: "updated",
                label: "时间",
                width: "200"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(getDisplayTime(scope.row.updated)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "toolName",
                label: "模块名",
                width: "200"
              }),
              _createVNode(_component_el_table_column, {
                prop: "content",
                label: "内容"
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, isLoading.value]
          ])
        : _createCommentVNode("", true)
  ]))
}
}

})